import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

interface PaymentPlanEditProps {
  paymentPlan: {
    amount_agreed: string;
    first_payment_date: string;
    amount_paid: string;
  };
  onChange: (field: string, value: string) => void;
  onSubmit: (e: React.FormEvent) => void;
  loading: boolean;
}

export const PaymentPlanEdit = ({ paymentPlan, onChange, onSubmit, loading }: PaymentPlanEditProps) => {
  return (
    <Card className="p-6 bg-[#222222] border-white/10">
      <h3 className="text-lg font-semibold text-white mb-4">Payment Plan</h3>
      <form onSubmit={onSubmit} className="space-y-4">
        <div>
          <label className="text-sm font-medium text-gray-400">Monthly Payment Amount</label>
          <Input
            type="number"
            step="0.01"
            value={paymentPlan.amount_agreed}
            onChange={(e) => onChange('amount_agreed', e.target.value)}
            required
            min="0"
            className="mt-1"
          />
        </div>

        <div className="space-y-2 bg-gray-900/50 p-4 rounded-lg">
          <p className="text-sm text-gray-400">
            Payment Structure:
            <br />• First 3 months: 100% to company
            <br />• After 3 months: 10% to company, 90% to creditors
          </p>
        </div>

        <div>
          <label className="text-sm font-medium text-gray-400">First Payment Date</label>
          <Input
            type="date"
            value={paymentPlan.first_payment_date}
            onChange={(e) => onChange('first_payment_date', e.target.value)}
            required
            className="mt-1"
          />
        </div>

        <div>
          <label className="text-sm font-medium text-gray-400">Amount Already Paid (if any)</label>
          <Input
            type="number"
            step="0.01"
            value={paymentPlan.amount_paid}
            onChange={(e) => onChange('amount_paid', e.target.value)}
            required
            min="0"
            className="mt-1"
          />
        </div>

        <Button type="submit" disabled={loading} className="w-full">
          {loading ? "Saving..." : "Save Payment Plan"}
        </Button>
      </form>
    </Card>
  );
};